import { AfterViewInit, Directive, ElementRef, OnInit, Optional, Renderer2, Self } from '@angular/core';
import { FormControl, FormControlName, NgControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[formControlName]',
})
export class RequiresFormDirective implements AfterViewInit, OnInit {
    private subscriptions: Subscription = new Subscription();

    private controlName!: string | number | null;
    private control!: FormControl;

    private elParent!: any;

    constructor(
        private el: ElementRef,
        private formControlName: FormControlName,
        private renderer: Renderer2,

        @Optional() @Self() private ngControl: NgControl
    ) {}

    ngOnInit(): void {
        this.controlName = this.formControlName.name;
        this.control = this.ngControl.control as FormControl;
        this.elParent = this.el.nativeElement.parentElement;

        if (!this.elParent.querySelector('label')) {
            this.elParent = this.el.nativeElement.parentElement.parentElement;
        }
        this.subscriptions.add(
            this.control.statusChanges.subscribe(() => {
                if (this.control?.hasValidator(Validators.required)) {
                    if (this.control.enabled) {
                        this.setRequired();
                    } else {
                        this.removeRequired();
                    }
                }
            })
        );
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.control?.hasValidator(Validators.required)) {
                if (this.control.enabled) {
                    this.setRequired();
                } else {
                    // this.subscriptions.add(
                    //     this.control.enabledChanges().subscribe(() => {
                    //         if (this.control?.enabled) this.setRequired();
                    //         if (this.control?.disabled) this.removeRequired();
                    //     })
                    // );
                }
            }
        }, 100);
    }
    setRequired() {
        const element = this.elParent.querySelector(`label`);
        if (element && !element.classList.contains('toggle-switch-label')) {
            if (!element.querySelector(`span[id="req-${this.controlName}"]`)) {
                const asterisk = this.renderer.createElement('span');
                this.renderer.addClass(asterisk, 'text-danger');
                const text = this.renderer.createText(' *');
                this.renderer.appendChild(asterisk, text);
                this.renderer.setAttribute(asterisk, 'id', `req-${this.controlName}`);
                this.renderer.appendChild(element, asterisk);
            }
        }
    }
    removeRequired() {
        const element = this.elParent.querySelector(`label`);
        if (element) {
            if (element.querySelector(`span[id="req-${this.controlName}"]`)) {
                const elementSpan = element.querySelector(`span[id="req-${this.controlName}"]`);
                this.renderer.removeChild(element, elementSpan);
            }
        }
    }
}
